
  import { STORE_GRID_TYPES } from '@loavies/c2c-models'

  export default {
    props: {
      skeletonsAmount: {
        type: Number,
        default: 24,
      },
      gridType: {
        type: String,
        default: 'default',
        validator(value) {
          return !value || Object.values(STORE_GRID_TYPES).includes(value)
        },
      },
      showLargeProductCards: {
        type: Boolean,
        default: false,
      },
      fullWidth: {
        type: Boolean,
        default: false,
      },
    },
  }
